import { useState } from "react";
import { Box } from "@mui/material";
import { colors, radii } from "../../../theme/designTokens";

// Wraps existing upload UI with native HTML5 drag-and-drop handlers.
// Does not replace click-to-browse — it's an additive overlay that calls
// the same onDropFiles(files) callback a parent already uses for uploads.
export default function DropZone({ onDropFiles, children, sx }) {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files || []);
    if (files.length > 0) onDropFiles(files);
  };

  return (
    <Box
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      sx={{
        borderRadius: radii.md,
        transition: "background-color 0.15s, box-shadow 0.15s",
        ...(isDragging && {
          bgcolor: colors.primaryLight,
          boxShadow: `inset 0 0 0 2px ${colors.primary}`,
        }),
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
